<div class="container">
  <div class="page">
    <div class="page-header">
      <h1 class="page-title">
        {{'Lost password' | translate}}
      </h1>
    </div>

    <div class="page-body">

      <div class="content-wrapper">

        <div class="content">

         <div class="mb-4">
           {{'Fill in your email so we can send you an email if you are in our system.' | translate}}
         </div>

          <div class="form-group">
            <label>{{'Email' | translate}}</label>
            <input class="form-control" [(ngModel)]="form.email" />
          </div>

          <button class="btn btn-primary">
            {{'Reset password' | translate}}
          </button>

        </div>

      </div>


    </div>
  </div>
</div>

